import agenda from './agenda'
import alerta from './alerta'
import armazem from './armazem'
import armazemCota from './armazemCota'
import autenticacao from './autenticacao'
import candidatos from './candidatos'
import checklist from './checklist'
import listaChegadas from './listaChegadas'
import log from './log'
import macro from './macros'
import misc from './misc'
import sms from './sms'
import usuario from './usuario'
import veiculo from './veiculo'

export default {
  agenda,
  alerta,
  armazem,
  armazemCota,
  autenticacao,
  candidatos,
  checklist,
  listaChegadas,
  log,
  macro,
  misc,
  sms,
  usuario,
  veiculo,
}
